import { tallyIcon } from "./images";

export const poolMetaInfos = {
    0: {
        avatar: tallyIcon,
        logo: tallyIcon,
        title: "Earn Tally",
        subscription: "Stake Tally",
    },
};